import { CoreIcon } from '../core-icon';
import arrowRightCircleSVG from '../../assets/icons/arrow-right-circle.svg';
import type { IconProps } from '../core-icon';

export const ArrowRightCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowRightCircleSVG} {...props} />;
};
